/* unplugin-vue-components disabled */import { render } from "./details.vue?vue&type=template&id=9fdf650c&scoped=true"
const script = {}

import "./details.vue?vue&type=style&index=0&id=9fdf650c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fdf650c"]])

export default __exports__